import * as React from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Grid, TextField } from "@material-ui/core";
import { SnackbarNotifier } from "../panel/MUI";
import { SvgIcon } from "../../components";
import { tl } from "../../utils";
import * as styles from "./styles.scss";
import { IAPIData, IAuthedInfo } from "./types";

export const AuthedForm = ({
  authData,
  setAuthData,
}: {
  authData: IAuthedInfo;
  setAuthData: React.Dispatch<React.SetStateAction<IAuthedInfo>>;
}) => {
  const history = useHistory();

  const onSignOut = async () => {
    await fetch(`/account/logout`, {
      method: "post",
    });

    setAuthData(null);
    history.goBack;
  };

  return (
    <div className={`${styles.wrap} ${styles.wrapRestore}`}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <SnackbarNotifier
            inline
            note={{
              message: (
                <Box className={styles.authed}>
                  {tl("Вы вошли в систему как")}
                  <br />
                  {authData.name}
                </Box>
              ),
              messageType: "success",
              hideIcon: true,
              centered: true,
            }}
            className="nominwidth"
          />
        </Grid>
        <Grid item container spacing={2}>
          <Grid data-testid="continueBtn" item xs={12} sm={6}>
            <Button
              variant="contained"
              color="primary"
              href={authData.continueLink}
              fullWidth
            >
              {tl("Продолжить обучение")}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button variant="contained" fullWidth onClick={onSignOut}>
              {tl("Сменить аккаунт")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
